import { hasDarkBlueHeroTone } from '../utils/heroTone';

type HeroOverlayProps = {
  imageUrl?: string;
  className?: string;
  preserveSourceTone?: boolean;
};

export function HeroOverlay({
  imageUrl,
  className = 'overlay',
  preserveSourceTone = false,
}: HeroOverlayProps) {
  const hasSourceTone = hasDarkBlueHeroTone(imageUrl);
  if (preserveSourceTone && hasSourceTone) return null;

  const correctionClass = hasSourceTone ? ' hero-overlay-tone-correction' : '';
  return <div className={`${className}${correctionClass}`} aria-hidden="true" />;
}
